<script setup lang="ts">
import Tag from 'primevue/tag';
import { useEnvironment } from '@/composables/useEnvironment';

// `slim` renders a compact dot for the collapsed sidebar; the full sidebar gets
// a labelled tag.
defineProps<{ slim?: boolean }>();

const { isNonProduction, environmentLabel, apiBaseUrl } = useEnvironment();

// Surfaces the exact backend on hover — handy when debugging which API is live.
const title = `${environmentLabel} environment — ${apiBaseUrl}`;
</script>

<template>
    <template v-if="isNonProduction">
        <span
            v-if="slim"
            :class="$style.dot"
            :title="title"
            role="img"
            :aria-label="`${environmentLabel} environment`"
        />
        <Tag
            v-else
            :value="environmentLabel ?? 'DEV'"
            severity="warn"
            :class="$style.tag"
            :title="title"
        />
    </template>
</template>

<style module>
.tag {
    @apply text-[0.625rem] font-bold uppercase tracking-wider leading-none px-2 py-1;
}

.dot {
    @apply inline-block w-2.5 h-2.5 rounded-full bg-amber-500 shrink-0;
    box-shadow: 0 0 0 3px rgb(251 191 36 / 0.25);
}
</style>
